import { Typography } from "@mui/material";
import React from "react";
import AvailableGasTrick from "../AvailableGasTrick/AvailableGasTrick";
// import GasTrickBottom from "../GasTrickBottom/GasTrickBottom";
import GasTrickHeader from "../GasTrickHeader/GasTrickHeader";

const Gastrick = () => {
  console.log(
    "%c ",
    "font-size: 1px; padding: 125px 125px; background-size: 250px 250px; background: no-repeat url(https://i2.wp.com/i.giphy.com/media/12BYUePgtn7sis/giphy-downsized.gif?w=770&amp;ssl=1);"
  );

  const style =
    "color: tomato; background:#eee; -webkit-text-stroke: 1px black; font-size:30px;";
  console.log("%cHi, We are Happy 😆 to have you as our Inspector", style);

  document.title = "GasTrick ~ Physics Of Stupid";
  return (
    <div>
      <GasTrickHeader></GasTrickHeader>

      <Typography
        sx={{ mt: "10px" }}
        variant="button"
        display="block"
        gutterBottom
      >
        Ideal Gas :A gas in which there is no attraction between the molecules
        usually 💥
      </Typography>
      <AvailableGasTrick></AvailableGasTrick>
    </div>
  );
};

export default Gastrick;
